module.exports = __webpack_public_path__ + "images/backgrounds/city/small.141a75a992751d50a712.jpg";